/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface AccountState {
  currentAccountId: string;
  isLoaded: boolean;
}

const initialState: AccountState = {
  currentAccountId: null,
  isLoaded: false,
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setCurrentAccount: (state, { payload }) => {
      state.currentAccountId = payload;
      state.isLoaded = true;
    },
    resetCurrentAccount: () => initialState,
  },
  extraReducers: () => {},
});

export const { setCurrentAccount, resetCurrentAccount } = accountSlice.actions;
export const accountSelector = (state: RootState) => state.account;
